/* 陳記元寶水餃・秋冬囤貨（dumpling-q4-2026）滿 $1,280 自動送豬肉片 1 包
 *
 * 行為（與 8 月颱風檔同骨架，門檻從「水餃包數」改成「金額」）：
 * - 門檻＝排除「贈品 variant 所有行」（含客人自買，與 Shopify 端排除
 *   collection 的 BXGY 規則一致）後的 cart.items 商品小計
 *   （final_line_price，含活動價；不含運費）≥ NT$1,280 → 自動放入贈品 1 包
 *   ——贈品商品自己不計門檻，防「湊門檻換免費肉片」
 * - 每單限 1 包，不累送（滿 $2,560 也只送 1 包）
 * - 行的管理只認帶 _auto_gift=dumpling-q4-2026 標記的贈品行；
 *   客人自己加購的豬肉片（沒有 marker）一律不動、也不計門檻
 * - 跌破門檻時自動把贈品行數量歸零移除
 * - 贈品庫存 0（inventoryPolicy=DENY）時 /cart/add.js 會失敗，靜默不重試轟炸
 * - 活動期間外（2026-10-12 14:30 ~ 2026-11-30 23:59:59 台北以外）整支不動作
 * - 贈品放進去後若 Shopify 沒有把它折成 $0（例如同單另有和鑽牛任選折扣，
 *   Shopify 只挑對客人較划算的那條），立刻移除，不讓客人被收贈品的錢；
 *   同一組購物車內容（不含贈品）不再重放，內容一變才重新判斷
 *
 * 由 promo_dumpling_q4_2026.py apply 上傳到佈景 assets/，毋須手工編輯 theme.liquid。
 */
(function () {
  var GIFT_VARIANT = 55748268490825;
  var MARK = "dumpling-q4-2026";
  var THRESHOLD_CENTS = 128000; // NT$1,280
  var START = Date.parse("2026-10-12T06:30:00Z"); // 2026-10-12 14:30:00 台北
  var END = Date.parse("2026-11-30T15:59:59Z"); //  2026-11-30 23:59:59 台北（含）
  if (Date.now() < START || Date.now() > END) return; // 活動視窗外自動停用
  var busy = false;
  var of = window.fetch;
  var DECLINED_KEY = "hg_gift_declined_" + MARK;
  var declinedMemo = null;

  function isGiftVariantLine(i) {
    return i.variant_id === GIFT_VARIANT;
  }

  function isGiftLine(i) {
    return i.variant_id === GIFT_VARIANT && i.properties && i.properties._auto_gift === MARK;
  }

  function eligibleSubtotalCents(cart) {
    var s = 0;
    (cart.items || []).forEach(function (i) {
      if (!isGiftVariantLine(i)) s += i.final_line_price;
    });
    return s;
  }

  // 購物車內容簽章（不含贈品 variant 的行），用來記「這組內容下贈品沒被折成 $0」
  function cartSig(cart) {
    return (cart.items || [])
      .filter(function (i) {
        return !isGiftVariantLine(i);
      })
      .map(function (i) {
        return i.variant_id + "x" + i.quantity;
      })
      .sort()
      .join(",");
  }

  function getDeclined() {
    try {
      return window.sessionStorage.getItem(DECLINED_KEY);
    } catch (e) {
      return declinedMemo;
    }
  }

  function setDeclined(sig) {
    declinedMemo = sig;
    try {
      window.sessionStorage.setItem(DECLINED_KEY, sig);
    } catch (e) {}
  }

  function removeLine(line) {
    return of.call(window, "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: line.key, quantity: 0 }),
    });
  }

  // 放完贈品後重讀購物車：贈品行沒被折成 $0 就移除並記下簽章
  function verifyGiftFree() {
    return of
      .call(window, "/cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var line = null;
        cart.items.forEach(function (i) {
          if (isGiftLine(i)) line = i;
        });
        if (line && line.final_line_price > 0) {
          setDeclined(cartSig(cart));
          return removeLine(line);
        }
      });
  }

  function desired(subtotal) {
    return subtotal >= THRESHOLD_CENTS ? 1 : 0; // 每單限 1 包，不累送
  }

  function swapSection(html, sel) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var src = doc.querySelector(sel),
      dst = document.querySelector(sel);
    if (src && dst) dst.innerHTML = src.innerHTML;
  }

  function refresh() {
    var onCart = location.pathname.replace(/\/$/, "") === "/cart";
    if (onCart) {
      location.reload();
      return Promise.resolve();
    }
    return fetch("/?sections=cart-drawer,cart-icon-bubble")
      .then(function (r) {
        return r.json();
      })
      .then(function (s) {
        if (s["cart-drawer"]) swapSection(s["cart-drawer"], "#CartDrawer");
        if (s["cart-icon-bubble"]) {
          var dst = document.getElementById("cart-icon-bubble");
          if (dst) {
            var doc = new DOMParser().parseFromString(s["cart-icon-bubble"], "text/html");
            dst.innerHTML = doc.body.innerHTML;
          }
        }
      })
      .catch(function () {});
  }

  // 忙碌期間（正在讀／改購物車）若又有購物車變動，記 pending，結束後補跑一次；
  // 不可直接丟掉，否則「頁面剛載入就加購」或連續加購時會漏放贈品。
  var pending = false;
  function sync() {
    if (busy) {
      pending = true;
      return;
    }
    busy = true;
    pending = false;
    // 自己的購物車請求一律走原生 fetch（of），不觸發下方的攔截，避免自我遞迴。
    of.call(window, "/cart.js")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var line = null;
        cart.items.forEach(function (i) {
          if (isGiftLine(i)) line = i;
        });
        var sig = cartSig(cart);
        var want = desired(eligibleSubtotalCents(cart)),
          have = line ? line.quantity : 0;
        if (line && want > 0 && line.final_line_price > 0) {
          setDeclined(sig);
          return removeLine(line).then(refresh);
        }
        if (!line && want > 0 && getDeclined() === sig) return null;
        if (want === have) return null;
        if (!line && want > 0)
          return of
            .call(window, "/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: [{ id: GIFT_VARIANT, quantity: want, properties: { _auto_gift: MARK } }] }),
            })
            .then(verifyGiftFree)
            .then(refresh);
        if (line)
          return of
            .call(window, "/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: line.key, quantity: want }),
            })
            .then(refresh);
      })
      .catch(function () {})
      .then(function () {
        busy = false; // 等請求真的結束才解除忙碌，避免兩輪同時加贈品
        if (pending) setTimeout(sync, 300);
      });
  }

  window.fetch = function () {
    var args = arguments;
    var u = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
    var p = of.apply(this, args);
    if (/\/cart\/(add|change|update|clear)/.test(u))
      p.then(function () {
        setTimeout(sync, 400);
      });
    return p;
  };
  var ox = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    try {
      if (/\/cart\/(add|change|update|clear)/.test(u))
        this.addEventListener("load", function () {
          setTimeout(sync, 400);
        });
    } catch (e) {}
    return ox.apply(this, arguments);
  };
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(sync, 600);
    });
  else setTimeout(sync, 600);
})();
